import { JSX, ReactNode, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Col, Grid, Row } from 'antd';
import ButtonC from 'src/components/Forms/Button';
import Advertising from 'src/components/Home/Article/Advertising';
import CardArticle from 'src/components/Home/Article/CardArticle';
import g from 'src/constants/global';
import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE_ONLY_FIVE } from 'src/constants/pagination';
import { TargetArrayType } from 'src/interface/AdSlot/index';
import { actionGetRelatedArticles } from 'src/redux/actions/articleByGroup';
import deviceSizeC from 'src/utils/device-size-client';
import { removeQueryParams } from 'src/utils/func';

import classes from './style.module.css';
import cn from "src/utils/cn";

interface CategoryPageLayoutProps {
	children: ReactNode | JSX.Element | ReactNode;
	header?: ReactNode | JSX.Element | ReactNode;
	adSource: string;
	adTarget: TargetArrayType;
}

const GPT = dynamic(() => import('src/components/GPT'), { ssr: false });
const CategoryPageLayout = (props: CategoryPageLayoutProps) => {
	const dispatch = useDispatch();
	const router = useRouter();
	const homepage = useSelector((state: RootStateOrAny) => state.homepage);
	const isDetailPage = props.adSource.indexOf('detail') !== -1;
	const dataAds = homepage.banner?.data?.record?.ads?.ads || [];
	const breakpoint = Grid.useBreakpoint();
	const relatedArticles = useSelector(
		(state: RootStateOrAny) => state.articleByGroup.relatedArticles,
	);
	const [pagination, setPagination] = useState({
		page: DEFAULT_PAGE_INDEX,
		per_page: DEFAULT_PER_PAGE_ONLY_FIVE,
	});

	const getArticles = async (slug: string) => {
		dispatch(
			await actionGetRelatedArticles(slug, {
				...pagination,
			}),
		);
	};
	useEffect(() => {
		if (router.pathname && pagination.per_page > 5) {
			getArticles(removeQueryParams(router.asPath));
		}
	}, [router.pathname, pagination]);

	return (
		<div className="container">
			{deviceSizeC(breakpoint) === 'desktop' && (
				<GPT
					name="gpt-ad-article-desktop-banner"
					adUnit={
						isDetailPage ? g.AD.DTL_ARTICLE_LLEADERBOARD_UNIT : g.AD.CTG_ARTICLE_LLEADERBOARD_UNIT
					}
					size={
						isDetailPage ? g.AD.DTL_ARTICLE_LLEADERBOARD_SIZE : g.AD.CTG_ARTICLE_LLEADERBOARD_SIZE
					}
					target={props.adTarget}
					className={cn(classes['ad-article-lleaderboard'], {
						[classes.detail]: isDetailPage,
					})}
				/>
			)}
			{deviceSizeC(breakpoint) === 'mobile' && (
				<GPT
					name="gpt-ad-landing-category-general-halfbanner"
					adUnit={
						isDetailPage
							? g.AD.DTL_ARTICLE_MOBILE_HALFBANNER_UNIT
							: g.AD.CTG_ARTICLE_MOBILE_HALFBANNER_UNIT
					}
					size={
						isDetailPage
							? g.AD.DTL_ARTICLE_MOBILE_HALFBANNER_SIZE
							: g.AD.CTG_ARTICLE_MOBILE_HALFBANNER_SIZE
					}
					target={props.adTarget}
					className={cn(classes['ad-article-halfbanner'], {
						[classes.detail]: isDetailPage,
					})}
				/>
			)}
			{props.header}
			<Row gutter={[24, 8]}>
				<Col xs={24} sm={24} md={24} lg={16} xl={16} style={{ overflow: 'hidden' }}>
					{props.children}
				</Col>
				<Col lg={8} xl={8} xs={24} sm={24} md={24} style={{ overflow: 'hidden' }}>
					{(breakpoint.xl || breakpoint.lg) && (
						<Advertising
							ads={dataAds}
							adSource={props.adSource}
							adTarget={props.adTarget}
							adUnits={[
								isDetailPage ? g.AD.DTL_ARTICLE_HALFPAGE_UNIT : g.AD.CTG_ARTICLE_HALFPAGE_UNIT,
								isDetailPage ? g.AD.DTL_ARTICLE_MEDIUMREC_UNIT : g.AD.CTG_ARTICLE_MEDIUMREC_UNIT,
							]}
							sizes={[
								isDetailPage ? g.AD.DTL_ARTICLE_HALFPAGE_SIZE : g.AD.CTG_ARTICLE_HALFPAGE_SIZE,
								isDetailPage ? g.AD.DTL_ARTICLE_MEDIUMREC_SIZE : g.AD.CTG_ARTICLE_MEDIUMREC_SIZE,
							]}
						/>
					)}
					{relatedArticles.length != 0 && relatedArticles?.data?.records?.length != 0 && (
						<div className="mb-12">
							<p className={classes['header-article']}>Artikel Terkait</p>
							<div className={classes.section}>
								<CardArticle showLabel data={relatedArticles?.data?.records} hideHeadingTitle />
							</div>
							{relatedArticles?.data?.records?.length <
								relatedArticles.meta?.pagination?.total_records &&
								relatedArticles?.data?.records?.length < 10 && (
									<ButtonC
										className={classes['button-article']}
										type="primary"
										size="large"
										text="Tampilkan Lebih Banyak"
										onClick={() =>
											setPagination((prev) => ({
												...prev,
												page: 1,
												per_page: prev.per_page + 5,
											}))
										}
									/>
								)}
						</div>
					)}
				</Col>
			</Row>
		</div>
	);
};

export default CategoryPageLayout;
